"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const valueIsUndefined_1 = __importDefault(require("../typeAssertions/valueIsUndefined"));
const wrapCallbackProcessesWithFunctionLogger_1 = __importDefault(require("./wrapCallbackProcessesWithFunctionLogger"));
const wrapCallbackWithFunctionLogger = ({ parentFunctionId, callbacks, functionLogger, }) => Object
    .entries(callbacks)
    .reduce((accum, [callbackName, callbackProcesses]) => {
    if ((0, valueIsUndefined_1.default)(callbackProcesses)) {
        return accum;
    }
    return Object.assign(Object.assign({}, accum), { [callbackName]: (0, wrapCallbackProcessesWithFunctionLogger_1.default)({
            parentFunctionId,
            callbackName,
            callbackProcesses,
            functionLogger,
        }) });
}, {});
exports.default = wrapCallbackWithFunctionLogger;
